export default __webpack_public_path__ + "static/media/danesh 512 512.39daa44b.png";